/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState:
    | { currentUser?: API.CurrentUser; permissionCodes?: string[] }
    | undefined,
) {
  const { currentUser } = initialState ?? {};
  const permissionCodes = initialState?.permissionCodes ?? [];
  const permissionSet = new Set(permissionCodes);
  const canAdmin = Boolean(currentUser && currentUser.access === 'admin');
  return {
    canAdmin,
    hasPermission: (code: string) => canAdmin || permissionSet.has(code),
    hasAnyPermission: (codes: string[]) =>
      canAdmin || codes.some((code) => permissionSet.has(code)),
  };
}
